import baseApi from "@/api/baseApi";
import notification from "@/helpers/notification";
import { transformDownload } from "@/helpers/saveFile";

const api = {
  async downloadBlob(att: any, container?: any) {
    if (att.guid) {
      let url = `/blob/download/${att.guid}`;

      if (container) {
        url += `?container=${container}`;
      }

      const response = await baseApi({
        method: "get",
        responseType: "blob",
        url: url,
        transformResponse: transformDownload,
      });
      return response.data;
    } else {
      notification.error("Feil ved nedlasting");
    }
  },
};

export default api;
